export const publicLabsCatalog = {
  catalogNav: "Labs Catalog",
  browseTitle: "Labs catalog",
  browseDescription: "Browse functional lab tests and panels.",
  companiesTitle: "Lab companies",
  companiesDescription: "Browse tests by laboratory.",
  logIn: "Log in",
  signUp: "Sign up",
  homeAriaLabel: "Fullscript",
};
